import { Icon } from "lucide-react";
import { WelcomeH3 } from "./SectionShell";
import { Colors } from "../../../styles/theme";

export function WelcomeHowItWorks() {
  return (
    <div className="mt-6">
      <WelcomeH3>Veja como funciona</WelcomeH3>
      <p className="mt-1 text-sm leading-relaxed text-slate-600">
        Tudo acontece automaticamente para facilitar sua vida
      </p>

      <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-4">
        {[
          {
            Icon: (
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_118_416" fill="white">
                  <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" />
                </mask>
                <path
                  d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                  fill="#034EA2"
                />
                <path
                  d="M0 20M40 20M40 20M0 20M20 0M40 20M20 40M0 20M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z"
                  fill="#E6E6E6"
                  mask="url(#path-1-inside-1_118_416)"
                />
                <path
                  d="M18 21C18.4295 21.5741 18.9774 22.0491 19.6066 22.3929C20.2357 22.7367 20.9315 22.9411 21.6467 22.9923C22.3618 23.0435 23.0796 22.9403 23.7513 22.6897C24.4231 22.4392 25.0331 22.047 25.54 21.54L28.54 18.54C29.4508 17.597 29.9548 16.3339 29.9434 15.023C29.932 13.712 29.4061 12.4579 28.4791 11.5309C27.5521 10.6038 26.298 10.078 24.987 10.0666C23.676 10.0552 22.413 10.5592 21.47 11.47L19.75 13.18M22 19C21.5705 18.4259 21.0226 17.9508 20.3934 17.607C19.7642 17.2633 19.0684 17.0589 18.3533 17.0076C17.6382 16.9564 16.9204 17.0596 16.2486 17.3102C15.5769 17.5608 14.9668 17.9529 14.46 18.46L11.46 21.46C10.5492 22.403 10.0452 23.666 10.0566 24.977C10.068 26.288 10.5938 27.542 11.5209 28.4691C12.4479 29.3961 13.702 29.922 15.0129 29.9334C16.3239 29.9447 17.5869 29.4408 18.53 28.53L20.24 26.82"
                  stroke="#E6E6E6"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ),
            title: "Sistema identifica",
            desc: "Detecta eventos ou mudanças importantes nos seus dados governamentais",
          },
          {
            Icon: (
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_118_443" fill="white">
                  <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" />
                </mask>
                <path
                  d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                  fill="#034EA2"
                />
                <path
                  d="M0 20M40 20M40 20M0 20M20 0M40 20M20 40M0 20M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z"
                  fill="#E6E6E6"
                  mask="url(#path-1-inside-1_118_443)"
                />
                <path
                  d="M26 28C26 26.4087 25.3679 24.8826 24.2426 23.7574C23.1174 22.6321 21.5913 22 20 22M20 22C18.4087 22 16.8826 22.6321 15.7574 23.7574C14.6321 24.8826 14 26.4087 14 28M20 22C22.2091 22 24 20.2091 24 18C24 15.7909 22.2091 14 20 14C17.7909 14 16 15.7909 16 18C16 20.2091 17.7909 22 20 22ZM30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10C25.5228 10 30 14.4772 30 20Z"
                  stroke="#E6E6E6"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ),
            title: "Analisa perfil",
            desc: "Verifica suas preferências e canais de comunicação cadastrados",
          },
          {
            Icon: (
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_118_469" fill="white">
                  <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" />
                </mask>
                <path
                  d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                  fill="#034EA2"
                />
                <path
                  d="M0 20M40 20M40 20M0 20M20 0M40 20M20 40M0 20M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z"
                  fill="#E6E6E6"
                  mask="url(#path-1-inside-1_118_469)"
                />
                <path
                  d="M18.3 29C18.4674 29.3044 18.7135 29.5583 19.0125 29.7352C19.3116 29.912 19.6526 30.0053 20 30.0053C20.3475 30.0053 20.6885 29.912 20.9876 29.7352C21.2866 29.5583 21.5327 29.3044 21.7 29M12 10C10.8 11.7 10 13.7 10 16M30 16C30 13.7 29.2 11.7 28 10M14 16C14 14.4087 14.6321 12.8826 15.7574 11.7574C16.8826 10.6321 18.4087 10 20 10C21.5913 10 23.1174 10.6321 24.2426 11.7574C25.3679 12.8826 26 14.4087 26 16C26 23 29 25 29 25H11C11 25 14 23 14 16Z"
                  stroke="#E6E6E6"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ),
            title: "Envia aviso",
            desc: "Prepara e envia a notificação de forma automática e segura",
          },
          {
            Icon: (
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_118_495" fill="white">
                  <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" />
                </mask>
                <path
                  d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                  fill="#034EA2"
                />
                <path
                  d="M0 20M40 20M40 20M0 20M20 0M40 20M20 40M0 20M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z"
                  fill="#E6E6E6"
                  mask="url(#path-1-inside-1_118_495)"
                />
                <path
                  d="M20 26H20.01M15 10H25C26.1046 10 27 10.8954 27 12V28C27 29.1046 26.1046 30 25 30H15C13.8954 30 13 29.1046 13 28V12C13 10.8954 13.8954 10 15 10Z"
                  stroke="#E6E6E6"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ),
            title: "Você recebe",
            desc: "A mensagem chega no seu canal preferido: push, WhatsApp ou e-mail",
          },
        ].map((s, idx) => (
          <div key={s.title} className="relative">
            {idx !== 0 ? (
              <div
                aria-hidden="true"
                className="absolute -left-6 top-[56px] hidden h-0.5 w-14 rounded-full sm:block"
                style={{ backgroundColor: Colors.AZUL_GOV_DARK }}
              />
            ) : null}
            <div className="flex flex-col items-center text-center">
              <span className="text-sm font-semibold">{s.Icon}</span>

              <div className="mt-2 text-sm font-semibold" style={{ color: Colors.GRAY_DARK }}>
                {s.title}
              </div>
              <div className="mt-1 whitespace-pre-line text-sm leading-relaxed" style={{ color: Colors.GRAY_DARK }}>
                {s.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
